export default function CancellationsRefund() {
    return (
        <section className="term-service privacy-Policy">
            <div className="term-and-service-h1">
                <h1>Cancellation and Refund Policy</h1>
            </div>
            <div className="container-wrap">
                <div className="term-service-wrpp">

                    <div className="term-and-service-p">
                        <p>At HubSyntax, we are committed to delivering high-quality and customized solutions to our clients. This Project Cancellation and Refund Policy outlines the conditions under which a client can cancel a project and get a refund.</p>
                    </div>
                    <div className="term-and-service-h2">
                        <h2>Cancellation Policy </h2>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Project Cancellation Notice</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Clients may request to cancel a project by submitting in written notice via email or our official communication channels.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Cancellation Timeframe</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If the project cancellation request is made within 12 to 48 hours before the project work has started, clients may receive a refund of any advance payments made.</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Cancellation request made after work is started on the project, you must pay for the work completed up to that point.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Cancellation Due to Client Delay</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If the project is delayed due to the client's failure to provide necessary information or approvals, HubSyntax reserves the right to suspend work and charge fees for the delay period.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Extra Hours Payment</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If the work done exceeds the amount already paid, the client must pay the remaining balance for that extra work. The rate for additional hours will be as per the hourly rate mentioned in the contract.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Project Postponed</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If the client postponed the project for any reason, all payments made up to that point will not be refunded to cover the work already completed. If the project resumes after an extended delay, we will not charge any additional fees.</p>
                    </div>
                    <div className="term-and-service-h2">
                        <h2>Refund Policy </h2>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Project-Based Refunds:</span> If the project is cancelled before any work has started, a partial refund may be issued. The refund amount is not guaranteed and will be decided by HubSyntax. Also, the setup and consultation costs will be deducted from the refund amount. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Unsatisfactory Work: </span> If you are not happy with our service, you must notify us in writing within 3 business days of receiving it. We'll check your request and decide if we can make changes, partial refund, or not give any refund.</p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Failed Cooperation:</span> If you delay feedback, fail to cooperate, or do not provide necessary information, we will not issue any refunds.</p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Chargebacks:</span> Requesting a refund without following our official refund policy or without providing a valid reason is considered a breach of our terms. In such cases, we have the right to suspend ongoing services and take appropriate legal actions if necessary.</p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Non-Refundable</p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We do not refund payments for completed design or development work. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Due Payments </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>Invoices pending for more than 7 days may be subject to a late fee of 15%. Accounts past due by 15 days or more may result in the suspension or termination of services. Services will not resume until the outstanding balance is paid in full. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Process for Cancellation and Refund </p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Notification:</span> Clients must notify HubSyntax in writing via email to start the cancellation process. The request must include the project details and a valid reason for cancellation. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Review:</span> HubSyntax will review the cancellation request and the work completed up to the cancellation date. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p> <span style={{ fontWeight: "800" }}>Refund Calculation:</span> The refund amount will be calculated based on the work completed and any applicable fees. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Processing Refunds </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We will process approved refunds within 14 business days of the cancellation request. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Dispute Resolution </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>If you have concerns about charges or services, contact us immediately at support@hubsyntax.com. </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>We will review your case and respond within 5 business days. </p>
                    </div>
                    <div className="term-and-service-bold">
                        <p>Contact Information </p>
                    </div>
                    <div className="term-and-service-p">
                        <p>For any questions or concerns regarding our Cancellation and Refund Policy, please contact us at: info@hubsyntax.com  </p>
                    </div>
                </div>
            </div>
        </section>
    )
}